import styled from 'styled-components';

export const StyledBtn = styled.button.attrs(({ btnType }) => ({
  type: btnType ? btnType : 'button'
}))`
  border-radius: ${({ rad }) => (rad ? rad : '4px')};
  width: ${({ width, auto }) => (auto ? 'auto' : width ? width : '128px')};
  height: ${({ height }) => (height ? height : '40px')};
  min-height: ${({ minHeight }) => (minHeight ? minHeight : '0px')};
  background: ${({ background }) => (background ? background : '')};
  background-color: ${({ bg, theme, transparent }) => (transparent ? 'transparent' : bg ? bg : theme.mocaGreen)};
  color: ${({ color, theme, transparent, bg }) => (transparent ? bg ? bg : theme.mocaGreen : color ? color : theme.white)};
  font-weight: ${({ weight }) => (weight ? weight : 'bold')};
  font-size: ${({ size }) => (size ? size : '14px')};
  border: ${({ bordered, bg, theme }) => (bordered ? `1px solid ${bg ? bg : theme.mocaGreen}` : 'none')};
  cursor: ${({ noclick }) => (!noclick ? 'pointer' : 'default')};
  transition: 0.3s;
  margin: ${({ margin }) => margin ? margin : 'inherit'};

  &:hover:enabled {
    opacity: ${({ noclick }) => (!noclick ? '0.8' : '1')};
    cursor: ${({ noclick }) => (!noclick ? 'pointer' : 'default')};
  }

  &:disabled {
    background-color: ${({ theme, transparent }) => (transparent ? 'transparent' : theme.mocaLtGrey)};
    color: ${({ theme, transparent }) => (transparent ? theme.mocaLtGrey : theme.white)};
  }
`